angular.module('mychart').controller('ImmunizationModalCtrl',
    ['$scope', '$uibModalInstance', '$window', 'patientImmunizations',
        function ($scope, $modalInstance, $window, patientImmunizations) {
            'use strict';

            $scope.model = {
                PatientImmunizations: patientImmunizations
            };

            function ok() {
                $modalInstance.close('ok');
            }

            function cancel() {
                $modalInstance.dismiss('cancel');
            }

            function print() {
                $window.print();
            }

            $scope.print = print;
            $scope.ok = ok;
            $scope.cancel = cancel;
        }]);
